import React, { useState } from 'react';
import { FiCalendar, FiChevronLeft, FiChevronRight, FiClock, FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AcademicCalendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date(2026, 1, 16)); // February 16, 2026

  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // Academic Events for 2026-2027
  const events2026 = {
    0: [ // January 2026
      { name: 'New Year Celebration', date: 1, color: 'blue' },
      { name: 'Makar Sankranti / Pongal', date: 14, color: 'orange' },
      { name: 'Republic Day', date: 26, color: 'red' }
    ],
    1: [ // February 2026
      { name: 'Valentine / Friendship Day', date: 14, color: 'pink' },
      { name: 'Maha Shivaratri', date: 15, color: 'purple' },
      { name: 'National Science Day', date: 28, color: 'blue' }
    ],
    2: [ // March 2026
      { name: 'Holi', date: 3, color: 'pink' },
      { name: 'International Women\'s Day', date: 8, color: 'purple' },
      { name: 'Ramadan Begins', date: 18, color: 'green' }
    ],
    3: [ // April 2026
      { name: 'Ram Navami', date: 1, color: 'orange' },
      { name: 'Mahavir Jayanti', date: 2, color: 'orange' },
      { name: 'Good Friday', date: 3, color: 'blue' },
      { name: 'World Earth Day', date: 22, color: 'green' }
    ],
    4: [ // May 2026
      { name: 'Labour Day', date: 1, color: 'red' },
      { name: 'Mother\'s Day', date: 10, color: 'pink' },
      { name: 'Buddha Purnima', date: 22, color: 'purple' }
    ],
    5: [ // June 2026
      { name: 'World Environment Day', date: 5, color: 'green' },
      { name: 'School Reopens', date: 8, color: 'blue' },
      { name: 'International Yoga Day', date: 21, color: 'purple' }
    ],
    6: [ // July 2026
      { name: 'Van Mahotsav Week', date: 7, color: 'green' },
      { name: 'Investiture Ceremony', date: 15, color: 'blue' }
    ],
    7: [ // August 2026
      { name: 'Independence Day', date: 15, color: 'orange' },
      { name: 'Ganesh Chaturthi', date: 27, color: 'orange' },
      { name: 'Raksha Bandhan', date: 29, color: 'pink' },
      { name: 'Janmashtami', date: 30, color: 'blue' }
    ],
    8: [ // September 2026
      { name: 'Onam', date: 5, color: 'yellow' },
      { name: 'Teachers\' Day', date: 5, color: 'red' },
      { name: 'Hindi Diwas', date: 14, color: 'orange' }
    ],
    9: [ // October 2026
      { name: 'Gandhi Jayanti', date: 2, color: 'orange' },
      { name: 'Navratri Begins', date: 9, color: 'yellow' },
      { name: 'Dussehra', date: 18, color: 'yellow' },
      { name: 'Halloween Activity', date: 31, color: 'orange' }
    ],
    10: [ // November 2026
      { name: 'Diwali', date: 8, color: 'orange' },
      { name: 'Children\'s Day', date: 14, color: 'blue' },
      { name: 'Annual Day', date: 21, color: 'purple' }
    ],
    11: [ // December 2026
      { name: 'Human Rights Day', date: 10, color: 'blue' },
      { name: 'Christmas Celebration', date: 25, color: 'red' },
      { name: 'Winter Carnival', date: 28, color: 'blue' }
    ]
  };

  const events2027 = {
    0: [ // January 2027
      { name: 'New Year Celebration', date: 1, color: 'blue' },
      { name: 'Makar Sankranti / Pongal', date: 14, color: 'orange' },
      { name: 'Republic Day', date: 26, color: 'red' }
    ],
    1: [ // February 2027
      { name: 'Valentine / Friendship Day', date: 14, color: 'pink' },
      { name: 'National Science Day', date: 28, color: 'blue' }
    ],
    2: [ // March 2027
      { name: 'Maha Shivaratri', date: 5, color: 'purple' },
      { name: 'International Women\'s Day', date: 8, color: 'purple' },
      { name: 'Holi', date: 22, color: 'pink' }
    ],
    3: [ // April 2027
      { name: 'Ram Navami', date: 20, color: 'orange' },
      { name: 'Mahavir Jayanti', date: 21, color: 'orange' },
      { name: 'World Earth Day', date: 22, color: 'green' },
      { name: 'Good Friday', date: 26, color: 'blue' }
    ],
    4: [ // May 2027
      { name: 'Labour Day', date: 1, color: 'red' },
      { name: 'Mother\'s Day', date: 9, color: 'pink' },
      { name: 'Buddha Purnima', date: 11, color: 'purple' }
    ],
    5: [ // June 2027
      { name: 'World Environment Day', date: 5, color: 'green' },
      { name: 'School Reopens', date: 7, color: 'blue' },
      { name: 'International Yoga Day', date: 21, color: 'purple' }
    ],
    6: [ // July 2027
      { name: 'Van Mahotsav Week', date: 5, color: 'green' },
      { name: 'Investiture Ceremony', date: 15, color: 'blue' }
    ],
    7: [ // August 2027
      { name: 'Independence Day', date: 15, color: 'orange' },
      { name: 'Raksha Bandhan', date: 18, color: 'pink' },
      { name: 'Janmashtami', date: 19, color: 'blue' }
    ],
    8: [ // September 2027
      { name: 'Teachers\' Day', date: 5, color: 'red' },
      { name: 'Ganesh Chaturthi', date: 15, color: 'orange' },
      { name: 'Hindi Diwas', date: 14, color: 'orange' },
      { name: 'Onam', date: 24, color: 'yellow' }
    ],
    9: [ // October 2027
      { name: 'Gandhi Jayanti', date: 2, color: 'orange' },
      { name: 'Dussehra', date: 7, color: 'yellow' },
      { name: 'Diwali', date: 27, color: 'orange' },
      { name: 'Halloween Activity', date: 31, color: 'orange' }
    ],
    10: [ // November 2027
      { name: 'Children\'s Day', date: 14, color: 'blue' },
      { name: 'Annual Day', date: 20, color: 'purple' }
    ],
    11: [ // December 2027
      { name: 'Human Rights Day', date: 10, color: 'blue' },
      { name: 'Christmas Celebration', date: 25, color: 'red' },
      { name: 'Winter Carnival', date: 30, color: 'blue' }
    ]
  };

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    
    const days = [];
    
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }
    
    // Add all days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(day);
    }
    
    return days;
  };

  const changeMonth = (direction) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + direction);
    setCurrentDate(newDate);
  };

  const days = getDaysInMonth(currentDate);
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const today = new Date();
  const isCurrentMonth = currentMonth === today.getMonth() && currentYear === today.getFullYear();
  const currentDay = isCurrentMonth ? today.getDate() : null;

  // Get events for current month - use after currentYear is defined
  const allEvents = currentYear === 2026 ? events2026 : events2027;
  const monthEvents = allEvents[currentMonth] || [];
  const eventDates = monthEvents.map(e => e.date);

  // Separate upcoming and past events
  const upcomingEvents = monthEvents.filter(e => !currentDay || e.date >= currentDay);
  const completedEvents = monthEvents.filter(e => currentDay && e.date < currentDay);

  return (
    <section className="py-16 bg-gradient-to-br from-blue-900 via-indigo-900 to-purple-900 relative overflow-hidden" id="calendar">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full mix-blend-overlay filter blur-xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-300 rounded-full mix-blend-overlay filter blur-xl animate-pulse animation-delay-2000"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-10" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-3">
            Mark the Date
          </h2>
          <p className="text-lg text-blue-100">
            Stay updated with all the upcoming events and important dates
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {/* Calendar Section */}
          <div className="lg:col-span-1 bg-white rounded-3xl p-8 shadow-2xl" data-aos="fade-right">
            {/* Calendar Header */}
            <div className="flex items-center justify-between mb-8">
              <button
                onClick={() => changeMonth(-1)}
                className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 flex items-center justify-center transition-all duration-200"
                aria-label="Previous month"
              >
                <SafeIcon icon={FiChevronLeft} className="w-6 h-6 text-blue-900" />
              </button>
              
              <h3 className="text-2xl font-bold text-blue-900 text-center min-w-[140px]">
                {monthNames[currentMonth]}
                <div className="text-sm font-medium text-gray-500">{currentYear}</div>
              </h3>
              
              <button
                onClick={() => changeMonth(1)}
                className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 flex items-center justify-center transition-all duration-200"
                aria-label="Next month"
              >
                <SafeIcon icon={FiChevronRight} className="w-6 h-6 text-blue-900" />
              </button>
            </div>

            {/* Calendar Grid */}
            <div className="grid grid-cols-7 gap-2 mb-6">
              {daysOfWeek.map((day) => (
                <div key={day} className="text-center font-bold text-gray-400 text-xs py-2">
                  {day}
                </div>
              ))}
            </div>

            <div className="grid grid-cols-7 gap-2 mb-6">
              {days.map((day, index) => (
                <div key={index} className="aspect-square">
                  {day && (
                    <button
                      className={`w-full h-full rounded-lg flex items-center justify-center font-semibold text-sm transition-all duration-200 ${
                        day === currentDay
                          ? 'bg-blue-900 text-white shadow-lg ring-2 ring-blue-400'
                          : eventDates.includes(day)
                          ? 'bg-red-100 text-red-600 font-bold hover:bg-red-200'
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      {day}
                    </button>
                  )}
                </div>
              ))}
            </div>

            {/* Legend */}
            <div className="pt-6 border-t border-gray-200 space-y-2">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 rounded-full bg-blue-900"></div>
                <span className="text-sm text-gray-600">Today</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 rounded-full bg-red-400"></div>
                <span className="text-sm text-gray-600">Has Events</span>
              </div>
            </div>
          </div>

          {/* Campus Buzz Section */}
          <div className="lg:col-span-2 bg-white rounded-3xl p-8 shadow-2xl" data-aos="fade-left">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Campus Buzz</h3>

            {/* Events Display */}
            <div className="space-y-4">
              {/* Upcoming Events */}
              {upcomingEvents.length > 0 && (
                <div>
                  <div className="flex items-center space-x-2 mb-4">
                    <div className="w-2.5 h-2.5 rounded-full bg-green-500"></div>
                    <span className="text-green-600 font-bold text-sm">UPCOMING EVENTS</span>
                  </div>

                  <div className="space-y-2.5 max-h-56 overflow-y-auto pr-2 custom-scrollbar">
                    {upcomingEvents.map((event, index) => (
                      <div
                        key={index}
                        className="flex items-start space-x-3 p-3 rounded-xl hover:bg-green-50 transition-all duration-300 border-l-3 border-green-400 bg-green-50/40"
                      >
                        <div className="w-8 h-8 rounded-lg bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <SafeIcon icon={FiClock} className="w-4 h-4 text-green-600" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h4 className="font-semibold text-sm text-gray-900">
                            {event.name}
                          </h4>
                          <p className="text-xs text-gray-500 mt-0.5">
                            {monthNames[currentMonth]} {event.date}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Completed Events */}
              {completedEvents.length > 0 && (
                <div className="pt-4 border-t border-gray-200">
                  <div className="flex items-center space-x-2 mb-4">
                    <div className="w-2.5 h-2.5 rounded-full bg-gray-400"></div>
                    <span className="text-gray-600 font-bold text-sm">COMPLETED EVENTS</span>
                  </div>

                  <div className="space-y-2">
                    {completedEvents.slice(0, 3).map((event, index) => (
                      <div
                        key={index}
                        className="flex items-start space-x-2.5 p-2.5 rounded-lg text-gray-500 text-xs bg-gray-50/50"
                      >
                        <SafeIcon icon={FiCheckCircle} className="w-4 h-4 mt-0.5 flex-shrink-0 text-gray-400" />
                        <div className="flex-1 min-w-0">
                          <p className="font-medium text-gray-700">{event.name}</p>
                          <p className="text-xs text-gray-400 mt-0.5">{monthNames[currentMonth]} {event.date}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* No Events Message */}
              {upcomingEvents.length === 0 && completedEvents.length === 0 && (
                <div className="text-center py-12">
                  <SafeIcon icon={FiCalendar} className="w-16 h-16 text-gray-200 mx-auto mb-3" />
                  <p className="text-gray-400 text-sm">No events scheduled for this month</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Custom Scrollbar Styles */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e0;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #a0aec0;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
      `}</style>
    </section>
  );
};

export default AcademicCalendar;
